/**
 * edj-legal-toc.js — Lot 7 Batch D EDJ
 * Sommaire interactif pages légales (sidebar desktop + SELECT mobile)
 *  - Click sidebar → scroll smooth + active class + dim des autres sections
 *  - Click SELECT mobile → scroll smooth
 *  - Scroll-spy desktop (IntersectionObserver) → met à jour active + dim
 *
 * Custom element <edj-legal-toc>.
 * Attendus dans le DOM :
 *   .edj-legal__toc-link[data-target="section-id"]   (boutons sidebar)
 *   .edj-legal__quicktoc-select                       (SELECT mobile)
 *   .edj-legal__section[id="section-id"]              (sections)
 */
(function () {
  'use strict';

  if (customElements.get('edj-legal-toc')) return;

  function smoothScrollTo(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    history.replaceState(null, '', '#' + id);
  }

  class EdjLegalTOC extends HTMLElement {
    connectedCallback() {
      var sections = this.querySelectorAll('.edj-legal__section');
      var sidebarLinks = this.querySelectorAll('.edj-legal__toc-link');
      var selectEl = this.querySelector('.edj-legal__quicktoc-select');
      if (!sections.length) return;

      // Initial active = première section
      var activeId = sections[0].id;
      this._setActive(activeId, sidebarLinks, sections);

      // Sidebar click
      Array.prototype.forEach.call(sidebarLinks, function (btn) {
        btn.addEventListener('click', function (e) {
          var target = btn.getAttribute('data-target');
          if (!target) return;
          e.preventDefault();
          smoothScrollTo(target);
        });
      });

      // SELECT mobile change
      if (selectEl) {
        selectEl.addEventListener('change', function (e) {
          var v = e.target.value;
          if (v) smoothScrollTo(v);
        });
      }

      // Scroll-spy desktop
      var self = this;
      if ('IntersectionObserver' in window && window.matchMedia('(min-width: 1024px)').matches) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                self._setActive(entry.target.id, sidebarLinks, sections);
              }
            });
          },
          { rootMargin: '0px 0px -65% 0px', threshold: 0 }
        );
        Array.prototype.forEach.call(sections, function (s) {
          io.observe(s);
        });
      }
    }

    _setActive(id, sidebarLinks, sections) {
      Array.prototype.forEach.call(sidebarLinks, function (btn) {
        if (btn.getAttribute('data-target') === id) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
      Array.prototype.forEach.call(sections, function (s) {
        if (s.id === id) {
          s.classList.remove('is-dim');
        } else {
          s.classList.add('is-dim');
        }
      });
    }
  }

  customElements.define('edj-legal-toc', EdjLegalTOC);
})();
